import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {Storage} from '@ionic/storage';

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(private storage: Storage,
                public router: Router) {
    }

    canActivate(): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            this.storage.get('token').then(res => {
                if (res) {
                    resolve(true);
                } else {
                    this.router.navigate(['/login']).then();
                    resolve(false);
                }
            });
        });
    }
}
